import GoogleMapComponent from './GoogleMapComponent';

export default class Marker extends GoogleMapComponent {
  initialize(props) {
    const { icon, isHTML, ...otherProps } = props;
    let marker;
    if (props.children || isHTML) {
      marker = new MarkerContainer(otherProps, this);
    } else {
      marker = new google.maps.Marker({
        icon,
        position: props.position,
      });
      if (props.onClick) marker.addListener('click', props.onClick);
    }
    return marker;
  }
}
